module.exports = __webpack_public_path__ + "static/image_13_thumb-6b99fdea3a3ec4721ef8e61b0d136432.jpg";